import Vue from "vue";
import Router from "vue-router";
import goTo from "vuetify/es5/services/goto";
//import store from "./store/store";
import applyMaintenanceGuard from './maintenanceGuard';

Vue.use(Router);

const customer_router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  // This is for the scroll top when click on any router link
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  },
  // This is for the scroll top when click on any router link
  routes: [
    {
      path: "/",
      redirect: "/authentication/login",
      component: () => import("@/layouts/blank-layout/Blanklayout"),
      children: [
        // Application
        {
          name: "Login",
          path: "/authentication/login",
          component: () => import("@/views/authentication/Login"),
          meta: { allowDuringMaintenance: true }
          //meta: { guest: true },
        },

        {
          name: "Dashboard",
          path: "/",
          redirect: "/authentication/login",
          component: () => import("@/layouts/full-layout/Layout"),
          children:
            [
              {
                name: "Dashboard",
                path: "dashboard",
                component: () => import("@/views/apps/pages/dashboard"),
                meta: { requiresAuth: true },
              },
              {
                name: "Customer",
                path: "customer",
                component: () => import("@/views/apps/pages/customer"),
                meta: { requiresAuth: true },
              },
              {
                name: "Add File",
                path: "add_file",
                component: () => import("@/views/apps/pages/add_file"),
                meta: { requiresAuth: true },
              },
              {
                name: "Carrier Login",
                path: "carrier_login",
                component: () => import("@/views/apps/pages/carrier_login"),
                meta: { requiresAuth: true },
              },
            ],

        },
      ],
    },

    {
      path: "/authentication",
      component: () => import("@/layouts/blank-layout/Blanklayout"),
      children: [
        {
          name: "Forget Password",
          path: "forgetpswd",
          component: () => import("@/views/authentication/forgetpswd"),
        },
        {
          name: "Reset Password",
          path: "resetpswd/:id",
          component: () => import("@/views/authentication/resetpswd"),
        },
        {
          name: "Test Login",
          path: "testlogin",
          component: () => import("@/views/authentication/testlogin"),
          //meta: { requiresAuth: true },
        },
        {
          name: "Test Login",
          path: "teststore",
          component: () => import("@/views/authentication/teststore"),
          //meta: { requiresAuth: true },
        },
        {
          name: "Logout",
          path: "logout",
          component: () => import("@/views/authentication/Logout"),
          meta: { requiresAuth: true },
        },
        {
          name: "BoxedLogin",
          path: "boxedlogin",
          component: () => import("@/views/authentication/BoxedLogin"),
        },
        {
          name: "FullLogin",
          path: "fulllogin",
          component: () => import("@/views/authentication/FullLogin"),
        },
        {
          name: "BoxedRegister",
          path: "boxedregister",
          component: () => import("@/views/authentication/BoxedRegister"),
        },
        {
          name: "FullRegister",
          path: "fullregister",
          component: () => import("@/views/authentication/FullRegister"),
        },
        {
          name: "Error",
          path: "error",
          component: () => import("@/views/authentication/Error"),
        },
      ],
    },
    {
      path: "*",
      component: () => import("@/views/authentication/Error"),
    },
  ],
});

import NProgress from "nprogress";

customer_router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start(800);
  }
  next();
});

customer_router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

applyMaintenanceGuard(customer_router);

// customer_router.beforeEach((to, from, next) => {
//   if (to.matched.some((record) => record.meta.requiresAuth)) {
//     let isAuthenticated = JSON.parse(localStorage.getItem("isAuthenticated"));

//     if (!isAuthenticated && to.path !== "/authentication/login") {
//     // if (!isAuthenticated) {
//       return next("/authentication/login");
//     }

//     if (isAuthenticated) {
//       next();
//       return;
//     }
//     next("/authentication/login");
//   } else {
//     next();
//   }
// });

customer_router.beforeEach((to, from, next) => {
  const isAuthenticated =
    localStorage.getItem("isAuthenticated") === "true";

  // If not logged in → allow ONLY login route
  if (!isAuthenticated) {
    if (to.path !== "/authentication/login") {
      return next("/authentication/login");
    }
  }
  next();
});

// router.beforeEach((to, from, next) => {
//   if (to.matched.some((record) => record.meta.guest)) {
//     if (store.getters.isAuthenticated) {
//       next("/apps/pages/dashboard");
//       return;
//     }
//     next();
//   } else {
//     next();
//   }
// });

export default customer_router;
